import '@/modules/misc/common/cookie-consent';

import throttle from 'lodash/throttle';

import DropdownHandler from '@/modules/misc/common/navbar/components/DropdownHandler.js';
import { initPreferredSourceBanners } from '@/services/preferred-source-banner';
import { sendTrackingEvent } from '@/services/trackService';

function initNavigation() {
  let dropdownHandlerInstance = null;

  const container = document.querySelector('.ds-header__navbar');
  const mainNav = document.querySelector('.ds-header__navbar__nav');
  const avatarWrapper = document.querySelector('.ds-header__navbar__avatar-wrapper');
  const dropdown = document.querySelector('.ds-header__navbar__avatar__mobileDropdown');
  const className = 'ds-header__navbar__avatar';
  const mobileMatcher = window.matchMedia('(max-width: 1279.98px)');

  function onNavigationElementClick(event) {
    if (event.currentTarget.target === '_blank') {
      return;
    }
    event.preventDefault();

    const li = event.currentTarget.parentElement;
    const liDropdown = li.querySelector('.ds-header__navbar__avatar__dropdown');

    // close another dropdowns
    dropdown.querySelectorAll('.ds-header__navbar__avatar__dropdown').forEach(el => {
      el.style.display = 'none';
    });

    // show dropdown
    liDropdown.style.display = 'block';

    // attach close button
    const header = liDropdown.querySelector('.ds-header__navbar__avatar__dropdown__header');
    header.addEventListener('click', e => {
      e.stopPropagation();
      liDropdown.style.display = 'none';
    });
  }

  function bindMobileNavigation() {
    const navLinks = document.querySelectorAll('.ds-header__navbar__nav__link');
    for (let i = 0; i < navLinks.length; i += 1) {
      navLinks[i].addEventListener('click', onNavigationElementClick);
    }
  }
  function unbindMobileNavigation() {
    const navLinks = document.querySelectorAll('.ds-header__navbar__nav__link');
    for (let i = 0; i < navLinks.length; i += 1) {
      navLinks[i].removeEventListener('click', onNavigationElementClick);
    }
  }

  function attachNavigation(isMobileDesign) {
    if (isMobileDesign) {
      dropdown.appendChild(mainNav);
      mainNav.classList.remove('none');
      container.classList.remove('ds-header__navbar__main-nav');
      bindMobileNavigation();

      if (dropdownHandlerInstance === null) {
        new DropdownHandler({
          wrapper: avatarWrapper,
          dropdown,
          wrapperClassName: `${className}--open`,
        }).startListening();

        dropdownHandlerInstance = true;
      }
    } else {
      container.appendChild(mainNav);
      mainNav.classList.add('none');
      container.classList.add('ds-header__navbar__main-nav');
      unbindMobileNavigation();
    }
  }

  attachNavigation(mobileMatcher.matches);

  mobileMatcher.addListener(() => {
    attachNavigation(mobileMatcher.matches);
  });
}

function initToC() {
  // https://www.tagvenue.com/blog/alternative-bucks-party-ideas/
  // https://www.tagvenue.com/blog/london-meetings-conferences-report/
  const tocLinks = document.querySelectorAll('.ub_table-of-contents a, .uagb-toc__wrap a');

  if (tocLinks.length === 0) {
    return;
  }

  for (let i = 0; i < tocLinks.length; i += 1) {
    tocLinks[i].addEventListener('click', e => {
      e.preventDefault();

      const href = e.currentTarget.href;
      if (href.indexOf('#') === -1) {
        window.location.href = href;
        return;
      }
      const id = href.split('#')[1];
      const element = document.getElementById(id);
      if (element === null) {
        window.location.href = href;
        return;
      }

      window.scrollTo({
        top: element.offsetTop - window.innerHeight / 5,
        behavior: 'smooth',
      });
    });
  }
}

function updateSlide(i, slider, slides) {
  const computedStyle = window.getComputedStyle(slides[0]);
  const slideWidth = slides[0].offsetWidth + parseInt(computedStyle.marginLeft, 10) + parseInt(computedStyle.marginRight, 10);
  const currentSlide = parseInt(slider.dataset.current, 10);
  const slidesInViewport = Math.round(slider.offsetWidth / slideWidth);

  if (i === '+') {
    i = currentSlide + slidesInViewport;

    if (currentSlide % slidesInViewport === 0 && slides.length - slidesInViewport < slidesInViewport) {
      i = slides.length - slidesInViewport;
    }
  }
  if (i === '-') {
    i = currentSlide - slidesInViewport;
  }

  if (i < 0) {
    if (currentSlide > 0 && currentSlide < slidesInViewport) {
      i = 0;
    } else {
      i = slides.length - slidesInViewport;
    }
  }
  if (i >= slides.length) {
    i = 0;
  }

  slider.dataset.current = i;

  const position = i * slideWidth;

  slider.scrollTo({ left: position, behavior: 'smooth' });
}

function initSlider() {
  const slider = document.querySelector('.blog-slider');
  const slides = document.querySelectorAll('.blog-slide');
  const dots = document.querySelectorAll('.blog-slider-dot');
  const arrowLeft = document.querySelector('.blog-slider-arrow-left');
  const arrowRight = document.querySelector('.blog-slider-arrow-right');
  const DOT_ACTIVE_CLASS = 'bg-grey-800';

  if (!slider || slides.length < 2) {
    return;
  }

  for (let i = 0; i < dots.length; i += 1) {
    dots[i].addEventListener('click', e => {
      e.preventDefault();

      updateSlide(i, slider, slides);
    });
  }

  slider.addEventListener('scroll', throttle(() => {
    const slideWidth = slides[0].offsetWidth;
    const currentSlide = Math.round(slider.scrollLeft / slideWidth);

    slider.dataset.current = currentSlide;

    for (let j = 0; j < dots.length; j += 1) {
      if (j === currentSlide) {
        dots[j].querySelector('span').classList.add(DOT_ACTIVE_CLASS);
      } else {
        dots[j].querySelector('span').classList.remove(DOT_ACTIVE_CLASS);
      }
    }
  }, 250));

  arrowLeft.addEventListener('click', e => {
    e.preventDefault();
    updateSlide('-', slider, slides);
  });
  arrowRight.addEventListener('click', e => {
    e.preventDefault();
    updateSlide('+', slider, slides);
  });
}

function initMostPopular() {
  const slider = document.querySelector('.blog-most-popular-slider');
  const slides = document.querySelectorAll('.blog-most-popular-slide');
  const arrowLeft = document.querySelector('.blog-most-popular-arrow-left');
  const arrowRight = document.querySelector('.blog-most-popular-arrow-right');

  if (!slider || slides.length < 4) {
    return;
  }

  arrowLeft.addEventListener('click', e => {
    e.preventDefault();
    updateSlide('-', slider, slides);
  });
  arrowRight.addEventListener('click', e => {
    e.preventDefault();
    updateSlide('+', slider, slides);
  });
}

function initFaq() {
  const sections = document.querySelectorAll('.schema-faq-section');
  if (sections.length === 0) {
    return;
  }

  sections.forEach(section => {
    const header = section.querySelector('.schema-faq-question');

    header.addEventListener('click', e => {
      e.preventDefault();

      if (section.classList.contains('opened')) {
        section.classList.remove('opened');
      } else {
        sections.forEach(s => {
          s.classList.remove('opened');
        });
        section.classList.add('opened');
      }
    });
  });

  sections[0].classList.add('opened');
}

initNavigation();
initToC();
initSlider();
initMostPopular();
initFaq();
initPreferredSourceBanners(payload => sendTrackingEvent({ event: 'blog_interaction', ...payload }));

sendTrackingEvent({ event: 'page_view' });
